<template>
    <div class="banner-container">
        <div 
            class="content"
            :style="imgStyle"
        >
          <div class="banner-text">
              <div class="title">{{title}}</div>
              <div class="mess">{{mess}}</div>
              <div class="describe">{{describe}}</div>
              <cloud-button
                v-if="router"
                :text="router"
                :handleClick="() => open(link)"
            ></cloud-button>
          </div>
        </div>
    </div>
    
</template>

<script>
import cloudButton from './cloudButton';
export default {
  name: "banner",
  components: {
      cloudButton: cloudButton
  },
  props: {
    router:{
      type: String,
      default: ""
    },
    link:{
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    mess: {
      type: String,
      default: ""
    },
    describe: {
      type: String,
      default: ""
    },
    hasButton: {
      type: Boolean,
      default: true
    },
    imgUrl: {
      type: String,
      default: '//img1.360buyimg.com/da/jfs/t1/120689/8/15967/266942/61528f04E873f3d75/6f638e5107a452b8.jpg!q80'
    }
  },
  computed: {
    imgStyle() {
      return `background-image:url(${this.imgUrl});`
    }
  },
  methods: {
    open(url) {
      if (!url) return
      window.open(url, '_blank')
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-container {
  width: 100%;
  overflow: hidden;
  height: 480px;
  margin-top: 60px;
  position: relative;

  .content {
    background-color: #fff;
    background-size: cover;
    transform: translateX(0px) scale(1);
    width: 100%;
    height: 100%;
    display: inline-block;
    background-position: 50%;
    background-repeat: no-repeat;

    .banner-text {
      width: 1216px;
      margin: 0 auto;
      text-align: left;
    }

    .title {
      color: #333;
      width: 550px;
      margin-top: 110px;
      font-size: 42px;
      line-height: 59px;
      font-weight: 500;
    }
    .mess{
      color: #333;
      margin-top: 16px;
      font-size: 22px;
      line-height: 22px;
      font-weight: 500;
    }

    .describe {
      color: #333;
      width: 456px;
      margin-top: 20px;
      font-size: 16px;
      line-height: 28px;
      margin-bottom: 45px;
      text-align: justify;
    }
  }
}
</style>

